module.exports = __webpack_public_path__ + "media/ruleta.ad9b02a1.mp3";